<template>
  <PageWrapper :isDense="isDense" :isLoading="isLoading">
    <template #title>
      ویرایش کلاس گروهی {{ defaultName ? defaultName : "" }}
    </template>
    <BRow class="mt-1" v-if="groupClassDetails">
      <BCol cols="12" md="6">
        <TextInput
          inputId="groupClassName"
          inputLabel="عنوان کلاس گروهی"
          inputPlaceholder="آیلتس مقدماتی"
          v-model="groupClassDetails.name"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="groupClassDuration"
          inputLabel="مدت زمان کلاس (دقیقه)"
          inputPlaceholder="50"
          v-model="groupClassDetails.duration"
        >
          <template #append> دقیقه </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="groupClassMinUserCapacity"
          inputLabel="حداقل تعداد شرکت کننده ها"
          inputPlaceholder="7"
          v-model="groupClassDetails.minUserCapacity"
        >
          <template #append> نفر </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="groupClassMaxUserCapacity"
          inputLabel="حداکثر تعداد شرکت کننده ها"
          inputPlaceholder="15"
          v-model="groupClassDetails.maxUserCapacity"
        >
          <template #append> نفر </template>
        </CustomAppendText>
      </BCol>

      <BCol cols="12" class="my-1">
        <BFormCheckbox
          v-model="isFreeGroupClass"
          name="free-group-class-checkbox"
          switch
        >
          <small style="margin-left: 3px">آیا کلاس گروهی رایگان است؟</small>

          <b>({{ isFreeGroupClass ? "بله" : "خیر" }})</b>
        </BFormCheckbox>
      </BCol>

      <BCol cols="12" md="6" v-if="!isFreeGroupClass">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="groupClassUserBasePrice"
          inputLabel="قیمت پایه زبان آموز"
          inputPlaceholder="50000"
          v-model="groupClassDetails.userBasePrice"
        >
          <template #append> تومان </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6" v-if="!isFreeGroupClass">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="groupClassMasterBasePrice"
          inputLabel="قیمت پایه استاد"
          inputPlaceholder="35000"
          v-model="groupClassDetails.masterBasePrice"
        >
          <template #append> تومان </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="auto" class="ml-auto mt-2">
        <BButton variant="info" @click="sendUpdateGroupClassRequest">
          ویرایش کلاس گروهی
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    isDense: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getASingleGroupClass();
  },
  data() {
    return {
      isLoading: false,
      defaultName: null,
      groupClassDetails: null,
      isFreeGroupClass: false,
    };
  },
  watch: {
    isFreeGroupClass: {
      handler(val) {
        if (val) {
          this.groupClassDetails.userBasePrice = 0;
          this.groupClassDetails.masterBasePrice = 0;
        } else {
          this.groupClassDetails.userBasePrice = null;
          this.groupClassDetails.masterBasePrice = null;
        }
      },
    },
  },
  methods: {
    async sendUpdateGroupClassRequest() {
      try {
        this.isLoading = true;
        const _this = this;
        const updateGroupClass = new UpdateGroupClass(_this);
        updateGroupClass.setRequestParamDataObj(_this.groupClassDetails);
        await updateGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کلاس گروهی با موفقیت ویرایش شد.",
              },
            });
            _this.getASingleGroupClass();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleGroupClass() {
      try {
        this.isLoading = true;
        const _this = this;
        const getASingleGroupClass = new GetASingleGroupClass(_this);
        getASingleGroupClass.setRequestParam({
          groupClassId: _this.$route.params.id,
        });
        await getASingleGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.defaultName = res.data.name;
            _this.groupClassDetails = res.data;
            if (
              _this.groupClassDetails.userBasePrice == 0 &&
              _this.groupClassDetails.masterBasePrice == 0
            ) {
              _this.isFreeGroupClass = true;
            }
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomAppendText,
    TextInput,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BRow, BCol, BButton, BFormCheckbox } from "bootstrap-vue";
import { GetASingleGroupClass, UpdateGroupClass } from "@/libs/Api/GroupClass";
</script>
